import { Box, Container, Grid, Skeleton } from "@mui/material";

const LoadingSkeleton = () => (
  <Container maxWidth="xl">
    <Box sx={{ py: 2 }}>
      <Grid container spacing={3}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} md={6} lg={6} key={item}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "background.paper",
                borderRadius: 2,
                boxShadow: 1,
                height: "100%",
              }}
            >
              {/* Header */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Box sx={{ flex: 1 }}>
                  <Skeleton width="70%" height={28} sx={{ mb: 1 }} />
                  <Skeleton width="40%" height={20} />
                </Box>
                <Skeleton width={32} height={32} variant="circular" />
              </Box>

              {/* Content */}
              <Box sx={{ mb: 2 }}>
                <Skeleton width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton width="90%" height={20} sx={{ mb: 1 }} />
                <Skeleton width="80%" height={20} />
              </Box>

              {/* Stats */}
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                {[1, 2, 3].map((stat) => (
                  <Box key={stat} sx={{ flex: 1 }}>
                    <Skeleton width="100%" height={24} sx={{ mb: 0.5 }} />
                    <Skeleton width="60%" height={20} />
                  </Box>
                ))}
              </Box>

              {/* Footer */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Skeleton width="30%" height={20} />
                <Skeleton width={100} height={36} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Container>
);

export default LoadingSkeleton;
